export const logoNegative = [
  '690 134',
  `
  <g
     id="layer1"
     transform="translate(-13.718753,-98.607214)">
    <circle
       style="opacity:0.2;fill:#000000;stroke-width:0;stroke-linecap:square;stroke-linejoin:round;stroke-miterlimit:5;stroke-dashoffset:3.28027;paint-order:stroke fill markers"
       id="path2"
       cx="174.67909"
       cy="165.60735"
       r="66" />
    <g
       id="g2"
       transform="translate(-57.054003)">
      <g
         id="g1"
         transform="matrix(1.5142197,0,0,1.5142197,-172.4522,-85.162136)"
         style="stroke-width:0.660406">
        <path
           id="path129"
           d="m 0,0 h -11.432 v 4.286 h 26.69 V 0 H 4.031 V -76.735 H 0 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,344.46849,136.7689)"
           clip-path="url(#clipPath130)" />
        <path
           id="path131"
           d="M 0,0 H -16.979 V -34.086 H 0 v -4.283 H -21.01 V 42.652 H 0 V 38.366 H -16.979 V 4.283 H 0 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,377.78829,167.3146)"
           clip-path="url(#clipPath132)" />
        <path
           id="path133"
           d="m 0,0 v -4.38 c 0,-9.266 3.011,-14.087 8.744,-14.087 5.839,0 8.736,3.779 8.736,16.353 0,10.275 -1.986,14.961 -9.23,21.398 -7.449,6.676 -11.026,10.449 -11.026,22.339 0,9.843 2.523,18.738 11.829,18.619 7.875,-0.119 11.408,-5.452 11.408,-17.271 v -3.179 h -4.029 v 3.053 c 0,7.836 -1.456,13.13 -7.487,13.13 -6.131,0 -7.69,-6.246 -7.69,-13.601 0,-9.381 1.662,-12.288 8.364,-18.335 8.951,-8.025 11.895,-12.292 11.895,-25.638 0,-11.285 -2.128,-21.132 -12.675,-21.132 -9.62,0 -12.87,7.564 -12.87,18.237 V 0 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,385.32929,180.5414)"
           clip-path="url(#clipPath134)" />
        <path
           id="path135"
           d="m 0,0 h -11.432 v 4.286 h 26.69 V 0 H 4.031 V -76.735 H 0 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,413.78269,136.7689)"
           clip-path="url(#clipPath136)" />
        <path
           id="path137"
           d="M 0,0 H -16.036 V -34.086 H 0 v -4.283 H -20.067 V 42.652 H 0 V 38.366 H -16.036 V 4.283 H 0 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,446.35139,167.3146)"
           clip-path="url(#clipPath138)" />
        <path
           id="path139"
           d="m 0,0 -17.035,52.565 -23.559,0.191 V 52.565 -30.22 h 0.301 12.142 2.719 V 33.668 L -5.195,-30.22 H 5.196 L 25.432,33.668 V -30.22 h 14.862 0.301 v 82.785 0.191 L 17.036,52.565 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,483.74457,174.581)"
           clip-path="url(#clipPath140)" />
        <path
           id="path141"
           d="M 0,0 V 15.223 H -0.544 -38.421 -53.583 V 0 -52.34 -67.563 H -38.421 0 v 12.858 2.365 h -38.421 v 18.559 h 37.877 v 15.222 H -38.421 V 0 Z"
           style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:0.292627"
           transform="matrix(0.79616076,0,0,-0.79616076,562.40907,144.8502)"
           clip-path="url(#clipPath142)" />
      </g>
      <path
         id="path220"
         clip-path="url(#clipPath221)"
         style="fill:#ffffff;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.32464"
         d="M -3.7500001e-4,22.280147 C -88.509163,22.280147 -166.42994,-23.703441 -211.28505,-92.99427 l -47.42578,43.37549 h -40.75049 l 74.47266,-67.30957 c -16.97349,-33.84648 -26.58692,-71.99576 -26.58692,-112.36817 0,-138.71986 112.85534,-251.57667 251.57520499999,-251.57667 C 138.71849,-480.87319 251.57629,-368.01638 251.57629,-229.29652 c 0,3.913 -0.0915,7.8879 -0.27246,11.8169 -1.68133,36.3404 -11.08954,71.30884 -27.32227,102.9375 l 71.83301,64.92334 h -40.75049 l -45.03369,-41.188478 c -10.28618,15.551933 -22.31914,30.084585 -36.07617,43.255372 C 126.91727,-2.5209306 65.13956,22.280147 -3.7500001e-4,22.280147 Z M -112.51063,-108.88636 c 2.93913,-0.15215 9.88866,-1.16446 20.437499,-6.83057 14.274986,-7.66799 72.511152,-34.84481 74.45215,-37.75781 1.940998,-2.911 21.221192,-22.396 21.221192,-22.396 l 71.979494,50.63819 14.084473,3.84375 c -14.081069,-11.03232 -26.612761,-24.92421 -39.788087,-40.26563 -26.902821,-31.32562 -51.6966081,-94.25145 -51.6987317,-94.25684 -0.0015,0.004 -24.7980373,62.93082 -51.7001963,94.25684 -18.836127,21.93289 -36.355513,40.91314 -58.987793,52.76807 z m -64.18213,-17.08594 c 25.81525,-0.0901 61.20296,-6.27286 88.104492,-34.06933 46.437954,-47.98296 66.667971,-115.03565 66.667971,-115.03565 l -21.38379,-20.39209 40.7915049,-65.44629 0.6899414,-1.1045 0.6884766,1.1045 40.7915051,65.44629 -21.38379,20.39209 c 0,0 20.229017,67.05269 66.667971,115.03565 46.134878,47.66965 116.569568,31.9081 121.536628,30.72509 13.10369,-27.11311 21.09125,-57.23479 22.57031,-89.1914 0.164,-3.587 0.24902,-7.21658 0.24902,-10.78858 0,-126.43387 -102.86298,-229.29639 -229.29785500001,-229.29639 C -126.43525,-458.59291 -229.2953,-355.73039 -229.2953,-229.29652 c 0,36.1486 8.43783,70.35141 23.40088,100.79297 5.78975,1.06514 16.03316,2.5772 29.20166,2.53125 z m 29.75098,-26.16504 c -32.69997,0 -59.20899,-26.50902 -59.20899,-59.20898 0,-32.69897 26.50902,-59.20752 59.20899,-59.20752 32.69996,0 59.208981,26.50855 59.208981,59.20752 0,32.69996 -26.509021,59.20898 -59.208981,59.20898 z m 290.23682,0 c -32.69897,0 -59.207522,-26.50902 -59.207522,-59.20898 0,-32.69897 26.508552,-59.20752 59.207522,-59.20752 32.69997,0 59.20898,26.50855 59.20898,59.20752 0,32.69996 -26.50901,59.20898 -59.20898,59.20898 z"
         transform="matrix(0.26632019,0,0,-0.26632019,232.13941,104.54106)" />
      <g
         id="g244"
         style="stroke-width:1.32464"
         transform="matrix(0.19974016,0,0,0.19974016,211.10413,-115.16917)">
        <path
           id="path234"
           d="m 0,0 -54.023,-49.41 c 0,0 -63.875,11.35 -119.615,-32.451 -51.518,-40.486 -83.249,-125.203 -83.249,-125.203 v 54.772 c 0,0 16.736,36.595 43.639,67.922 26.903,31.326 65.161,49.743 91.228,53.619 26.067,3.876 60.894,5.799 60.894,5.799 L -40.75,0 Z"
           style="fill:#fec200;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.32464"
           transform="matrix(1.3333333,0,0,-1.3333333,445.3977,1166.1379)"
           clip-path="url(#clipPath235)" />
        <g
           id="g243"
           style="stroke-width:1.32464">
          <path
             id="path232"
             d="m 0,0 -18.339,-29.921 c 0,0 -67.713,7.586 -119.714,-27.415 -35.327,-23.778 -78.084,-94.185 -78.084,-94.185 v 46.12 c 7.604,13.661 19.347,30.213 35.475,48.993 26.903,31.327 65.162,49.743 91.228,53.619 C -73.327,-0.394 -53.858,0.539 -40.751,0 -32.645,-0.333 0,0 0,0"
             style="fill:#f06a0f;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.32464"
             transform="matrix(1.3333333,0,0,-1.3333333,391.0644,1166.1379)"
             clip-path="url(#clipPath233)" />
          <path
             id="path238"
             d="m 0,0 18.338,-29.921 c 0,0 67.713,7.586 119.714,-27.415 35.328,-23.778 78.085,-94.185 78.085,-94.185 v 46.12 c -7.604,13.661 -19.348,30.213 -35.476,48.993 C 153.758,-25.081 115.5,-6.665 89.433,-2.789 73.327,-0.394 53.857,0.539 40.75,0 32.644,-0.333 0,0 0,0"
             style="fill:#f06a0f;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.32464"
             transform="matrix(1.3333333,0,0,-1.3333333,-185.3003,1166.1379)"
             clip-path="url(#clipPath239)" />
        </g>
        <path
           id="path240"
           d="m 0,0 54.024,-49.41 c 0,0 63.874,11.35 119.614,-32.451 51.518,-40.486 83.25,-125.203 83.25,-125.203 v 54.772 c 0,0 -16.737,36.595 -43.64,67.922 -26.903,31.326 -65.161,49.743 -91.227,53.619 -26.068,3.876 -60.895,5.799 -60.895,5.799 L 40.751,0 Z"
           style="fill:#fec200;fill-opacity:1;fill-rule:nonzero;stroke:none;stroke-width:1.32464"
           transform="matrix(1.3333333,0,0,-1.3333333,-239.6348,1166.1379)"
           clip-path="url(#clipPath241)" />
      </g>
    </g>
  </g>
 `,
]
